import React from 'react'
import Nav from 'react-bootstrap/Nav'

import Paths from 'js/utils/unauthorizedPaths'

import HeaderWrapper from './HeaderWrapper'
import { Link } from 'react-router-dom'

export default function Header(): React.ReactElement {
  return (
    <HeaderWrapper>
      <Nav.Link as={Link} to={Paths.signIn}>
        Sign In
      </Nav.Link>

      <Nav.Link as={Link} to={Paths.bareRegistrationLink}>
        Register
      </Nav.Link>
    </HeaderWrapper>
  )
}
